import { c as _c } from "react/compiler-runtime";
import { StreamingChannelsPanel } from "@/shared/components";
import { DetailSection } from "@/shared/ui";
import type { Profile } from "@/features/auth/api/types";
import classes from "../account-drawer.module.scss";
type StreamingChannelsSectionProps = Readonly<{
  profile: Profile;
  isLoading: boolean;
}>;
export function StreamingChannelsSection(t0) {
  const $ = _c(3);
  const {
    profile,
    isLoading
  } = t0;
  const hasChannels = profile.accountType === "STREAMER" && profile.streamingPlatforms.length > 0;
  if (!isLoading && !hasChannels) {
    return null;
  }
  let t1;
  if ($[0] !== isLoading || $[1] !== profile.streamingPlatforms) {
    t1 = <DetailSection label="STREAMING CHANNELS">{isLoading ? <div className={classes.panel}>{Array.from({
          length: 3
        }).map(_temp)}</div> : <StreamingChannelsPanel platforms={profile.streamingPlatforms} />}</DetailSection>;
    $[0] = isLoading;
    $[1] = profile.streamingPlatforms;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(_, index) {
  return <div key={index} className={classes.skeletonRow}><div className={classes.skeletonIcon} /><div className={classes.skeletonLine} /></div>;
}